module.exports = __webpack_public_path__ + "static/media/black-hopinion.03b2ab22.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/black-hopinion.png
// module id = 526
// module chunks = 0